import Cookies from "js-cookie";
import { Navigate, Route, Routes } from "react-router-dom";
import PreviewPetition from "../components/petitions/PreviewPetition/PreviewPetition";
import SMSVerification from "../components/verification/smsVerification/SMSVerification";
import VerificationSuccessed from "../components/verification/VerificationSuccess/VerificationSuccessed";
import About from "../pages/About/About";
import AISettingsPage from "../pages/AISettings/AISettingsPage";
import Analytics from "../pages/Analytics/Analytics";
import ConfirmEmailChangePage from "../pages/ConfirmEmailChangePage";
import ConfirmPage from "../pages/ConfirmPage";
import ConstructorPage from "../pages/ConstructorPage";
import Contacts from "../pages/Contacts/Contacts";
import DnsRecordsPage from "../pages/DnsRecordsPage";
import ErrorPage from "../pages/ErrorPage";
import ForgotPasswordEmailPage from "../pages/ForgotPasswordEmailPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import Home from "../pages/Home/Home";
import LoginPage from "../pages/LoginPage";
import NewsInfoPage from "../pages/NewsInfoPage";
import NewsPage from "../pages/NewsPage";
import NotFoundPage from "../pages/NotFoundPage/NotFoundPage";
import PasswordRecoveryPage from "../pages/PasswordRecoveryPage";
import CreatePetitionPage from "../pages/Petitions/CreatePetitionPage";
import CreatePetitionSuccessPage from "../pages/Petitions/CreatePetitionSuccessPage";
import EnhancedCreatePetitionPage from "../pages/Petitions/EnhancedCreatePetitionPage";
import EnhancedPetitionDetailsPage from "../pages/Petitions/EnhancedPetitionDetailsPage";
import MyPetitionDetailsPage from "../pages/Petitions/MyPetitionDetailsPage";
import MyPetitionsPage from "../pages/Petitions/MyPetitionsPage";
import PetitionDetailsPage from "../pages/Petitions/PetitionDetailsPage";
import PetitionEditPage from "../pages/Petitions/PetitionEditPage";
import PetitionSearchPage from "../pages/Petitions/PetitionSearchPage";
import PetitionsPage from "../pages/Petitions/PetitionsPage";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import ProfilePage from "../pages/ProfilePage";
import RegisterPage from "../pages/RegisterPage";
import VerificationInfoPage from "../pages/VerificationInfoPage";
import VerifyPage from "../pages/VerifyPage/VerifyPage";
import VoicePage from "../pages/VoicePage/VoicePage";

const PrivateRoute = ({ element }) => {
  const isAuthenticated = !!Cookies.get("accessToken");
  return isAuthenticated ? element : <Navigate to="/login" replace />;
};

const MainRoutes = () => {
  const ROUTES = [
    {
      id: 1,
      path: "/",
      element: <Home />,
    },
    {
      id: 2,
      path: "/petitions",
      element: <PetitionsPage />,
    },
    {
      id: 3,
      path: "/analytics",
      element: <Analytics />,
    },
    {
      id: 4,
      path: "/about",
      element: <About />,
    },
    {
      id: 5,
      path: "/register",
      element: <RegisterPage />,
    },
    {
      id: 6,
      path: "/login",
      element: <LoginPage />,
    },
    {
      id: 7,
      path: "/confirm",
      element: <ConfirmPage />,
    },
    {
      id: 8,
      path: "/voice",
      element: <VoicePage />,
    },
    {
      id: 9,
      path: "/ai-settings",
      element: <AISettingsPage />,
    },
    {
      id: 11,
      path: "/profile",
      element: <PrivateRoute element={<ProfilePage />} />,
    },
    {
      id: 12,
      path: "/mypetitions",
      element: <PrivateRoute element={<MyPetitionsPage />} />,
    },
    {
      id: 13,
      path: "/petitions/new",
      element: <CreatePetitionPage />,
    },
    {
      id: 111,
      path: "/create-petition",
      element: <EnhancedCreatePetitionPage />,
    },
    {
      id: 12,
      path: "/preview-petition",
      element: <PreviewPetition />,
    },
    {
      id: 13,
      path: "/petitions/:id",
      element: <PetitionDetailsPage />,
    },
    {
      id: 131,
      path: "/petition/:id",
      element: <EnhancedPetitionDetailsPage />,
    },
    {
      id: 14,
      path: "/edit-petition/:id",
      element: <PetitionEditPage />,
    },
    {
      id: 15,
      path: "/verification",
      element: <VerifyPage />,
    },
    {
      id: 16,
      path: "/confirm-email-change",
      element: <ConfirmEmailChangePage />,
    },
    {
      id: 17,
      path: "/verification-info",
      element: <PrivateRoute element={<VerificationInfoPage />} />,
    },
    {
      id: 18,
      path: "/petition-search",
      element: <PetitionSearchPage />,
    },
    {
      id: 19,
      path: "/dns-records",
      element: <DnsRecordsPage />,
    },
    {
      id: 20,
      path: "/constructor",
      element: <ConstructorPage />,
    },
    {
      id: 21,
      path: "/forgot-password",
      element: <ForgotPasswordPage />,
    },
    {
      id: 21,
      path: "/forgot-password-email",
      element: <ForgotPasswordEmailPage />,
    },
    {
      id: 22,
      path: "/password-recovery",
      element: <PasswordRecoveryPage />,
    },
    {
      id: 23,
      path: "/mypetitions/:id",
      element: <MyPetitionDetailsPage />,
    },
    {
      id: 24,
      path: "/create-petition-success",
      element: <CreatePetitionSuccessPage />,
    },
    {
      id: 25,
      path: "/error",
      element: <ErrorPage />,
    },
    {
      id: 26,
      path: "/news",
      element: <NewsPage />,
    },
    {
      id: 27,
      path: "/news/:id",
      element: <NewsInfoPage />,
    },
    {
      id: 28,
      path: "/verification-info/alternative-verification",
      element: <PrivateRoute element={<SMSVerification />} />,
    },
    {
      id: 29,
      path: "/privacy",
      element: <PrivacyPolicy />,
    },
    {
      id: 30,
      path: "/contacts",
      element: <Contacts />,
    },
    {
      id: 31,
      path: "/verified",
      element: <VerificationSuccessed />,
    },
  ];
  return (
    <Routes>
      {ROUTES.map((route) => (
        <Route key={route.id} path={route.path} element={route.element} />
      ))}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default MainRoutes;
